import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ServerErrorResponse } from '../types/server-error-response.model';

/**
 * This assumes standard error response type ServerErrorResponse, and
 * will transform it into a friendly error message for
 * our page-message component
 * @returns Observable
 */
export function convertServerError() {
  return <T>(source: Observable<T>): Observable<T> => source.pipe(
    catchError((e: ServerErrorResponse) => {
      if (Array.isArray(e?.error)) {
        return throwError(e.error);
      }

      /**
       * Throwing this warning in here, so we know
       * if we are using an invalid error message format
       */
      // eslint-disable-next-line no-console
      console.warn('Malformed error message');
      return throwError(e?.error?.messages || [ { key: null } ]);
    })
  );
}
